import { useTranslation } from 'src/i18n/client';

type Props = {
    locale: string;
    activeStep?: number;
    onActiveStepSelected?: (activeStep: number) => void;
};

export default function WizardSteps({ activeStep = 1, locale, onActiveStepSelected }: Props) {
    const { t } = useTranslation(locale, 'common');
    const steps = [
        t('appointments.wizard.tests'),
        t('appointments.wizard.locationDate'),
        t('appointments.wizard.personalDetails'),
        t('appointments.wizard.summary'),
    ];

    return (
        <ul className="mt-4 flex items-start pb-2 text-center lg:hidden">
            {steps.map((item, index) => {
                const opacity = index > activeStep ? 'opacity-25 ' : '';
                const beforeClassName = `before:bg-primary before:absolute before:left-0 before:right-1/2 before:top-1/2 before:mr-2 before:h-px${
                    index > activeStep ? ' before:opacity-25' : ''
                }`;
                const afterClassName = `after:bg-primary after:absolute after:left-1/2 after:right-0 after:top-1/2 after:ml-2 after:h-px${
                    index >= activeStep ? ' after:opacity-25' : ''
                }`;

                return (
                    <li
                        key={item}
                        className="relative w-1/4 cursor-pointer text-xs"
                        onClick={() => {
                            if (typeof onActiveStepSelected === 'function' && index < activeStep) {
                                onActiveStepSelected(index);
                            }
                        }}>
                        <div
                            className={`relative mb-1 h-3${index !== 0 ? ` ${beforeClassName}` : ''}${
                                index !== steps.length - 1 ? ` ${afterClassName}` : ''
                            }`}>
                            <div className={`${opacity}bg-primary inline-block h-3 w-3 rounded-full`} />
                        </div>
                        <div className={`${opacity}`}>{item}</div>
                    </li>
                );
            })}
        </ul>
    );
}
